import { createApp } from 'vue';
import Index from '../components/Contact/Landing/Index.vue';

const app = createApp(Index);
app.mount('#contact-us-landing-page');
